









import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import AttributeSet from "@/api/AttributeSet";
import Product from "@/api/Product";
import CompareService from "@/service/CompareService";
import CompareTableHeader from "@/components/Compare/CompareTable/CompareTableHeader.vue";
import CompareTableBody from "@/components/Compare/CompareTable/CompareTableBody.vue";
import Loading from "@/components/Shared/Loading.vue";

@Component({
  components: {Loading, CompareTableBody, CompareTableHeader}
})
export default class CompareTable extends Vue {
  @Prop() private productIds!: number[];
  @Prop() private attributeSet!: AttributeSet;
  @Prop({default: true}) private isMobile!: boolean;

  private products: Product[] | null = null;

  async getProductsFromServer() {
    if (this.productIds) {
      this.products = await CompareService.getProductsById(this.productIds);
    }
  }

  get trimmedProducts() {
    if(this.products) {
      if (this.isMobile) {
        if(this.products.length > 2) {
          return this.products.slice(0, 2);
        }
      }
      if(this.products.length > 4) {
        return this.products.slice(0, 4);
      }
    }
    return this.products;
  }

  async mounted() {
    await this.getProductsFromServer();
  }

  removeProduct(productId: number) {
    this.$emit("product-remove", productId);
  }

  @Watch('productIds')
  onProductIdsChanged() {
    this.getProductsFromServer();
  }
}
